import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
} from "antd";
import { useState } from "react";
import MainLayout from "../../../components/mainLayout";
import "./index.scss";
import Upload from '../../../commons/Upload';
import { authApis } from "../../../services/authApi";
import { nofication } from '../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";

const Register = () => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [data, setData] = useState();
    const [methodPay, setMethodPay] = useState();
    const [bankPay, setBankPay] = useState();
    const [form] = Form.useForm();
    let { id } = useParams();

    useState(() => {
        if (id) {
            authApis
                .detailOrder(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.data);
                        setMethodPay(data.data.methodPay);
                        setBankPay(data.data.bankPay);
                        setData(data.data);
                    } else {
                        nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                    }
                })
                .catch((errors) => {
                    nofication('error', 'Thất bại', 'Không kết nối được server');
                    console.log(errors);
                });
        }
    });

    const handleMethodPayChange = (value) => {
        setMethodPay(value);
    };
    const handleBankPayChange = (value) => {
        setBankPay(value);
    };

    const onFinish = async () => {
        const values = form.getFieldValue();
        const formData = new FormData();
        for (var key in values) {
            formData.append(key, values[key]);
        }
        formData.append("methodPay",methodPay);
        formData.append("bankPay", bankPay);
        console.log(formData);
        if (id) {
            formData.append("id", id);
        }
        // formData.append('logo', fileList);
        // formData.append('imageUrl', imageUrl);
        await authApis
            .updateOrder(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors);
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Order"
            link="/orders/edit"
            titleNew="Order / Edit "
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true} style={{ minHeight: 873 }}>
                <Row gutter={16}>
                    <Col span={24} style={{ paddingRight: "19px" }}>
                        <div className="box-class">
                            <Row gutter={16}>
                                <Col span={5}>
                                    <Form.Item label="Họ tên" name={`name`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Số điện thoại" name={`phone`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Địa chỉ" name={`address`}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item label="Xã" name={`xa`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Huyện" name={`huyen`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Tỉnh" name={`tinh`}>
                                        <Input />
                                    </Form.Item>

                                </Col>
                                <Col span={5}>
                                    <Form.Item label="Method Pay">
                                        <Select
                                            placeholder="Select Method Pay"
                                            value={methodPay}
                                            onChange={handleMethodPayChange}
                                        >
                                            <Select.Option value={1} key="COD">
                                                COD
                                            </Select.Option>
                                            <Select.Option value={2} key="BANK">
                                                BANK PAY
                                            </Select.Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="Total" name={`total`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Note" name={`ghichu`}>
                                        <Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
                                    </Form.Item>

                                </Col>
                                <Col span={5}>
                                    <Form.Item label="Code Discount" name={`codeDiscount`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Discount" name={`discount`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Note AD" name={`ghichuAd`}>
                                        <Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item label="Email" name={`email`}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="TK PAY">
                                        <Select
                                            placeholder="Select Method Pay"
                                            value={bankPay}
                                            onChange={handleBankPayChange}
                                        >
                                            <Select.Option value="1" key="THANG">
                                                TK Thắng
                                            </Select.Option>
                                            <Select.Option value="2" key="MANH">
                                                TK Mạnh
                                            </Select.Option>
                                            <Select.Option value="3" key="TUAN">
                                                TK Tuấn
                                            </Select.Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="Platform" name={`platform`}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item>
                                <Row
                                    justify="end"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
